import type { BackButtonEvent } from '@ionic/react';
import { useEffect } from 'react';

export const useBackButton = (onBackButton: () => void, enabled = true) => {
  useEffect(() => {
    const backbuttonInterceptor = (event: unknown) => {
      // adapted from https://ionicframework.com/docs/developing/hardware-back-button
      // where the default priorities are documented as well
      (event as BackButtonEvent).detail.register(10, processNextHandler => {
        if (enabled) {
          onBackButton();
        } else {
          processNextHandler();
        }
      });
    };

    document.addEventListener('ionBackButton', backbuttonInterceptor);

    return () => document.removeEventListener('ionBackButton', backbuttonInterceptor);
  }, [onBackButton, enabled]);
};
